/*!
 * consoleHook.js — console(s1, perform): the live console opened from a score
 * © 2026 Rob Canning — GPLv3
 *
 * A score's way into a live-coded section: the playhead (or a button) opens
 * the console on a #$ block and goes to it as a scene. The console does it
 * (oscillaLive.js): it registers here, and the cue (cueDispatcher.js) asks.
 * With no console on the page there is nothing to open: said, and nothing done.
 */

let runner = null;

/** The console's: (ast) => what it did. */
export function setConsoleRunner(fn) { runner = typeof fn === "function" ? fn : null; }

export function handleConsoleCue(ast) {
  if (!runner) {
    console.warn("[console] no live console on this page to open");
    return null;
  }
  return runner(ast);
}
